import { PROYECT, api_get, api_put } from "services/api";

import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
  buildCustomTableConfig,
} from "redux/actions/search/searchActions";

import { NOTES_TYPES } from "redux/reducers/buildings/notes/notesTypes";
import { divideAndCeil } from "helpers/mathDictionary";
import { filtersToParams } from "helpers/filtersToParams";

const { SET_NOTES, CLEAR_NOTES, HANDLE_NOTES_BUILDINGS_INPUTS } = NOTES_TYPES;

const urlNotes = `${process.env.REACT_APP_URL}${PROYECT}/buildings/notes`;

export function clearNotes() {
  return {
    type: CLEAR_NOTES
  };
}

export const handleNotesBuildingsInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_NOTES_BUILDINGS_INPUTS, payload: { key, value } });
}

export const fetchNotes = (
  idStation = null,
  page,
  size = 10,
  tableKey = "",
  filters = []
) => async dispatch => {
  dispatch(startRequestComp("loadingNotes"));
  const newPage = Number(page) + 1;

  const filtersParams = filtersToParams(filters);

  try {
    const response = await api_get(
      `${urlNotes}/stations/${idStation}?page=${newPage}&limit=${size}${filtersParams}`
    );

    const newPagination = {
      pageSize: response.pagination?.limit || 10,
      page: response.pagination?.page - 1 || 0,
      sorted: [],
      pages: divideAndCeil(
        Number(response.pagination?.total),
        Number(response.pagination?.limit)
      )
    };

    dispatch({
      type: SET_NOTES,
      payload: {
        notes: response.data
      }
    });

    dispatch(buildCustomTableConfig(tableKey, newPagination));
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("loadingNotes"));
};

export const sendNote = (idNote = null, onSuccess = null) => async dispatch => {
  dispatch(startRequestComp("loadingSendNote"));

  try {
    const response = await api_put(`${urlNotes}/${idNote}/send`);

    if (typeof onSuccess === "function") {
      onSuccess();
    }

    dispatch(setSnackbar(response.message, "success"));
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("loadingSendNote"));
};

export const applyPayment = (idNote, idOrigin, reference, onSuccess) => async dispatch => {
  dispatch(startRequestComp("applyPayment"));
  try {
    await api_put(`${urlNotes}/${idNote}/payment`, {
      source: idOrigin,
      reference: getReference(idOrigin, reference)
    });

    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("applyPayment"));
  }
};

export const reassignPayment = (idNote, idOrigin, action, reference, onSuccess) => async dispatch => {
  dispatch(startRequestComp("reassignPayment"));

  try {
    await api_put(`${urlNotes}/${idNote}/reassign`, {
      action,
      source: idOrigin,
      reference: getReference(idOrigin, reference)
    });

    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("reassignPayment"));
  }
};

export const getFile = (idNote = null, onSuccess = null) => async dispatch => {
  dispatch(startRequestComp("loadingFile"));

  try {
    const response = await api_get(`${urlNotes}/${idNote}/report`);

    if (typeof onSuccess === "function") {
      onSuccess();
    }

    window.open(response.url, "_blank", "noopener,noreferrer");
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingFile"));
  }
};

const getReference = (origin, reference) => {
  switch (origin) {
    case 'BANAMEX':
      return reference.reference
    case 'PAYMENT_LINK':
      return reference.id_charge
    default:
      return null
  }
}
